import { ReactNode } from 'react'
import { RiInboxLine } from '@remixicon/react'

interface EmptyStateProps {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
}

/**
 * What someone sees before they have anything — often their first minute in
 * the product. So it is written like an invitation rather than a report of
 * absence: the title carries the heading voice, and the action sits right
 * under it instead of being hunted for in a toolbar.
 */
export default function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center px-6 py-12 text-center">
      <span className="flex size-11 items-center justify-center rounded-full bg-gray-100 text-gray-400 dark:bg-gray-900 dark:text-gray-600">
        {icon ?? <RiInboxLine className="size-5" aria-hidden="true" />}
      </span>
      {/* Semibold and tight, but not the display size: most of these sit
          inside a card, under a section heading, and a title louder than the
          heading above it inverts the page's order. */}
      <h3 className="mt-4 text-base font-semibold tracking-tight text-gray-950 dark:text-white">
        {title}
      </h3>
      {description && (
        <p className="mt-1.5 max-w-sm text-sm text-gray-500 dark:text-gray-400">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  )
}
